import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuidService {

  constructor() { }
                            
  public emptyGuid: string ='00000000-0000-0000-0000-000000000000';
  public getGuid(): string {

    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  public getHash(charCount: number) {
    let hash = this.getGuid().replace(/-/g, '');

    while (hash.length < charCount) {
      hash = hash + this.getGuid().replace(/-/g, '');
    }

    hash = hash.substring(0, charCount);
    return hash;
  }
}
